module.exports = require("./ar-MR.d.ts");